import { Header } from "@/pages/home/sections/header/index"
import { HeroSection } from "@/pages/home/sections/hero/index"
import { AboutAcademySection } from "@/pages/home/sections/about-academy/index"
import { FeaturesSection } from "@/pages/home/sections/features/index"
import { CoursesOverview } from "@/pages/home/sections/courses/index"
// removed PopularCategories
import { TestimonialsSection } from "@/pages/home/sections/testimonials/index"
import { StatisticsSection } from "@/pages/home/sections/statistics/index"
import { CallToActionSection } from "@/pages/home/sections/cta/component"
import { Footer } from "@/pages/home/sections/footer"
import { DotsGridSection } from "@/pages/home/sections/dots-grid"
// removed MomentumGallerySection




export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutAcademySection />
        <FeaturesSection />
        <CoursesOverview />
        <TestimonialsSection />
        <StatisticsSection />
        <CallToActionSection />
        <DotsGridSection />
      </main>
      <Footer />
    </div>
  )
}
